export default class PathImage {
  static IMAGEM_INDISPONIVEL =
    "https://maiitre.com.br/imgs/geral/icones/imgindisponivel.webp";

  static IMAGEM_INDISPONIVEL_TUMB =
    "https://maiitre.com.br/imgs/geral/icones/imgindisponivel_thumb.webp";
}
